var Appearance = /** @class */ (function () {
    function Appearance(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'class,style';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Appearance.prototype.toJSON = function () {
        return {
            "class": this.class,
            "style": this.style
        };
    };
    Appearance.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Appearance;
}());
export { Appearance };
//# sourceMappingURL=appearance.js.map